export const blockIconsActivitiesEngineeringNew = (
	<span className='material-symbols-outlined'>engineering</span>
);
